<template>
  <ValidationObserver ref="optionForm">
    <div class="d-flex align-center">
      <ValidationProvider
        v-slot="{ errors }"
        rules="required"
        class="flex-grow-1 mr-2"
      >
        <v-text-field
          :error-messages="getErrorMessages(errors)"
          label=""
          class="mb-4 mt-2"
          v-model="option.option"
        />
      </ValidationProvider>
      <ValidationProvider v-slot="{ errors }" rules="required">
        <Select
          item-text="label"
          item-value="value"
          v-model="option.validResponse"
          :initialSelected="option.validResponse"
          :items="validResponseOptions"
          label=""
          placeholder=""
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
      <v-btn icon @click="remove" class="d-flex align-center mb-2 ml-2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select from "@/components/common/Select";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Select
  },
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      validResponseOptions: [
        {
          label: "Valid Answer",
          value: true
        },
        {
          label: "Invalid Answer",
          value: false
        }
      ],
      showValidationErrors: false
    };
  },
  methods: {
    remove() {
      this.$emit("remove");
    },
    async validateForm() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.optionForm.validate();
      return isValid;
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    }
  }
};
</script>

<style lang="scss"></style>
